import { Dispatch, SetStateAction, useRef } from "react";
import * as s from "../LoginStyled";
import { LOGIN_TAB } from "../LoginContainer";
import DW_CLOUD from "assets/images/dw_cloud_logo_w.png";
import DW_CLOUD_LIGHT from "assets/images/dw_cloud_logo_b.png";
import AuthPopup from "components/templates/modal/auth/AuthPopup";
import { getSpectrumAuthUrl } from "utils/AccountUtil";
import { BigButton, ButtonLabel } from "components/atoms/buttons/ButtonStyled";
import { getClientDevice } from "utils/functions";
import { AxiosInstance } from "api/axiosInstance";
import useApiError from "hook/useApiError";
import {
  CustomError,
  Validate,
  ValidateMsg,
} from "api/interfaces/commonInterface.interface";
import { GetLoginResponse } from "api/interfaces/authInterface.interface";
import { useAppSelector } from "redux/hooks";
import { ValidateWord } from "components/atoms/text/Text";

interface Props {
  validateMsg: ValidateMsg;
  setValidateMsg: Dispatch<SetStateAction<ValidateMsg>>;
  isValidated: Validate;
  setIsValidated: Dispatch<SetStateAction<Validate>>;
  onLoginSuccess: (data: GetLoginResponse) => void;
  setCloudLoading: Dispatch<SetStateAction<boolean>>;
}
export default function CloudLogin({
  validateMsg,
  setValidateMsg,
  isValidated,
  setIsValidated,
  onLoginSuccess,
  setCloudLoading,
}: Props) {
  const isLoadingCode = useRef(false);
  const theme = useAppSelector((state) => state.theme.theme);
  const { displayError, intlString, lang, createCustomError } = useApiError();
  const onCode = async (code: string) => {
    if (isLoadingCode.current) return;
    isLoadingCode.current = true;
    if (code !== undefined && code !== "") {
      try {
        const device = getClientDevice();
        setCloudLoading(true);
        // code를 이용해서 token들을 받아옴
        sessionStorage.setItem("code", code);
        const resp = await AxiosInstance.post("/auth/token", {
          code,
          device,
        });

        if (resp.status === 404) {
          setIsValidated({ ...isValidated, email: true });
          setValidateMsg({
            ...validateMsg,
            email: intlString(lang.validateMsg.signup.accountNotFound),
          });
        } else if (200 > resp.status || 300 < resp.status) {
          const error = createCustomError(
            resp.data,
            lang.validateMsg.signup.loginIncorrect
          );
          setIsValidated({ ...isValidated, email: true });
          setValidateMsg({
            ...validateMsg,
            email: displayError(error, lang.validateMsg.signup.loginIncorrect),
          });
        } else {
          onLoginSuccess(resp.data);
        }
      } catch (err: any) {
        if (err?.response?.data?.error === 5017) {
          setIsValidated({ ...isValidated, email: true });
          setValidateMsg({
            ...validateMsg,
            email: lang.validateMsg.login.DWCloudUserNotRegistered,
          });
          return;
        }
        setIsValidated({ ...isValidated, email: true });
        setValidateMsg({
          ...validateMsg,
          email: displayError(
            err as CustomError,
            lang.validateMsg.signup.loginIncorrect
          ),
        });
      } finally {
        setCloudLoading(false);
        isLoadingCode.current = false;
      }
    } else {
      isLoadingCode.current = false;
    }
  };
  return (
    <s.CloudLoginWrapper>
      <s.LoginInfo tab={LOGIN_TAB.DW_CLOUD}>
        <img
          src={theme === "light" ? DW_CLOUD_LIGHT : DW_CLOUD}
          alt="DW Cloud"
          style={{ width: "116px" }}
        />
        <p>
          Are you a member of the myDW organization?
          <br />
          If you have a DW Spectrum Web Portal account,{" "}
          <span className="inline-block">you can log into myDW with it.</span>
        </p>
      </s.LoginInfo>
      <AuthPopup
        url={getSpectrumAuthUrl()}
        onCode={onCode}
        onClose={() => null}
        title={"DW Spectrum Web Portal"}
        width={500}
        height={500}
      >
        <BigButton buttonType="secondary">
          <ButtonLabel>DW Spectrum Web Login</ButtonLabel>
        </BigButton>
      </AuthPopup>
      {validateMsg.email && (
        <s.ValidateWrapper>
          <ValidateWord data-testid="cloud-login-validate-email">
            {validateMsg.email}
          </ValidateWord>
        </s.ValidateWrapper>
      )}
    </s.CloudLoginWrapper>
  );
}
